module.exports = __webpack_public_path__ + "img/1697118874639.68b33417.jpg";